import { useState } from "react";

export default function useAPLModalStates() {
  const [supervisorInfoOpen, setSupervisorInfoOpen] = useState(false);
  const [aplPeriodOpen, setAplPeriodOpen] = useState(false);
  const [infoPersonOpen, setInfoPersonOpen] = useState(false);
  const [addNewWorkStepOpen, setAddNewWorkStepOpen] = useState(false);
  const [addNewWorkStepComponentOpen, setAddNewWorkStepComponentOpen] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const toggleSupervisorInfo = () => setSupervisorInfoOpen(prev => !prev);
  const toggleCreatePeriod = () => setAplPeriodOpen(prev => !prev);
  const toggleInfoPersonOpen = () => setInfoPersonOpen(prev => !prev);
  const toggleAddNewWorkStepModal = () => setAddNewWorkStepOpen(prev => !prev);
  const toggleAddNewWorkStepComponentModal = () => setAddNewWorkStepComponentOpen(prev => !prev);
  const toggleExportModal = () => setExportModalOpen(prev => !prev);

  return {
    supervisorInfoOpen,
    aplPeriodOpen,
    infoPersonOpen,
    addNewWorkStepOpen,
    addNewWorkStepComponentOpen,
    exportModalOpen,
    toggleSupervisorInfo,
    toggleCreatePeriod,
    toggleInfoPersonOpen,
    toggleAddNewWorkStepModal,
    toggleAddNewWorkStepComponentModal,
    toggleExportModal,
    setAddNewWorkStepComponentOpen,
  };
}
